import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { Breadcrumb } from "../Breadcrumb";
import { FooterBuffer } from "../FooterBuffer";

const Article = ({ blok }) => {
  console.log('test', blok)
  return (
    <>
      <div {...storyblokEditable(blok)} className="font-display main">
        <div className="container herosub">
          <Breadcrumb currentName={blok.title} />
          <h1>{blok.title}</h1>
          <h2>{blok.subtitle}</h2>
        </div>
        <div className="font-display text-left article-content">
          <div className="intro-image-wrap">
            <div className="intro-image">
              <img src={blok.introimage.filename} alt={blok.introimage.alt} />
            </div>
            {blok.body
              ? blok.body.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
        </div>
      </div>
      <FooterBuffer />
    </>
  );
};

export default Article;
